import React, { useEffect } from "react";
import { useOktaAuth, LoginCallback } from "@okta/okta-react";
import { useLocation } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import MainLayout from "./components/MainLayout";
import { setAuthenticatedUserContext } from './helpers/AppInsights';
import "./App.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BatchUploadContextProvider } from './components/BatchUpload/BatchUploadContext';
import { BetaLabsProvider } from './contexts/BetaLabsContext';
import { DarkThemeProvider } from './contexts/DarkThemeContext';

function App() {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();

  useEffect(() => {
    if (authState?.isAuthenticated && authState.idToken) {
      const userEmail = authState.idToken.claims.email || '';
      const userId = authState.idToken.claims.sub || '';      
      setAuthenticatedUserContext(userEmail, userId); //sending user's email as primary identifier
    }
  }, [authState]);

  // Explicitly handle the Okta callback route
  if (location.pathname === '/authorization-code/callback' || location.pathname === '/login/callback') {
    return <LoginCallback />;
  }

  // Allow /sign-out page to render without auth (user just logged out)
  if (location.pathname === '/sign-out') {
    return <AppRoutes />;
  }

 // Prevent rendering until Okta auth is resolved
  if (!authState || authState.isPending) {    
    return <div style={{textAlign: 'center', marginTop: '2rem'}}>Loading authentication...</div>;    
  }

  if (!authState.isAuthenticated) {
    oktaAuth.signInWithRedirect();
    return <div style={{textAlign: 'center', marginTop: '2rem'}}>Redirecting to login...</div>;
  }

  return (
    <MainLayout>
      <AppRoutes />
    </MainLayout>
  );
}

const AppWrapper = () => (
  <DarkThemeProvider>
    <BetaLabsProvider>
      <BatchUploadContextProvider>
        <App />
      </BatchUploadContextProvider>
    </BetaLabsProvider>
  </DarkThemeProvider>
);

export default AppWrapper;
